import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface CloseInvestigationCommand {
  readonly investigationId: string;
  readonly statusId: string;
  readonly closingReasonId: string;
  readonly closingNotes: string;
}

export interface CloseInvestigationResult {
  readonly success: boolean;
  readonly investigationId: string;
}

@Injectable({ providedIn: 'root' })
export class CloseInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _toast = inject(ToastProvider);

  public execute(command: CloseInvestigationCommand): Observable<CloseInvestigationResult> {
    return this._repository
      .closeInvestigation(command.investigationId, command.statusId, command.closingReasonId, command.closingNotes)
      .pipe(
        tap(() => {
          this._toast.success('Investigation closed', 'The investigation has been closed successfully.');
        }),
        map(() => ({ success: true, investigationId: command.investigationId })),
        catchError((error) => {
          this._toast.error('Failed to close investigation', 'Please try again or contact support.');
          return throwError(() => error);
        }),
      );
  }
}
